function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable } from "react-table";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { useQuery, useApolloClient } from "@apollo/client";
import "./OverTimeReport.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { isRateLimited } from "../utils";
import { OVER_TIME_REPORT_QUERY, OVER_TIME_REPORT_EXPORT_QUERY } from "./query";
import { GET_USER_LISTING_QUERY } from "../MonthlyInOut/query";
var LIMIT = 11;
var OverTimeReport = function OverTimeReport(props) {
  var _userListData$getUser, _overTimeReportData$o5, _overTimeReportData$o7;
  var client = useApolloClient();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isExporting = _React$useState2[0],
    setIsExporting = _React$useState2[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useState3 = React.useState(new Date()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    startDate = _React$useState4[0],
    setStartDate = _React$useState4[1];
  var _React$useState5 = React.useState({
      label: "All Members",
      value: null
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    userParameterCheck = _React$useState6[0],
    setUserParameterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    setIsAllLoaded(false);
    setIsLoadingMore(false);
  }, [startDate, userParameterCheck]);
  var userList = [{
    label: "All Members",
    value: null
  }];
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error;
  var dateMoment = moment(startDate);
  var _useQuery2 = useQuery(OVER_TIME_REPORT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value,
        startTime: Number(moment(dateMoment).startOf("month").format("x")),
        endTime: Number(moment(dateMoment).endOf("month").format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        userRole: role,
        workingDays: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.workingDays
      },
      skip: !organisationId || !teamId
    }),
    overTimeReportLoading = _useQuery2.loading,
    overTimeReportData = _useQuery2.data,
    overTimeReportError = _useQuery2.error,
    overTimeReportFetchMore = _useQuery2.fetchMore;
  React.useEffect(function () {
    if (userParameterCheck === null) {
      setUserParameterCheck({
        label: "All Members",
        value: null
      });
    }
  }, [userListData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  React.useEffect(function () {
    var _overTimeReportData$o, _overTimeReportData$o2, _overTimeReportData$o3, _overTimeReportData$o4;
    if ((overTimeReportData === null || overTimeReportData === void 0 ? void 0 : (_overTimeReportData$o = overTimeReportData.overTimeReport) === null || _overTimeReportData$o === void 0 ? void 0 : (_overTimeReportData$o2 = _overTimeReportData$o.userData) === null || _overTimeReportData$o2 === void 0 ? void 0 : _overTimeReportData$o2.length) !== 0 && (overTimeReportData === null || overTimeReportData === void 0 ? void 0 : (_overTimeReportData$o3 = overTimeReportData.overTimeReport) === null || _overTimeReportData$o3 === void 0 ? void 0 : (_overTimeReportData$o4 = _overTimeReportData$o3.userData) === null || _overTimeReportData$o4 === void 0 ? void 0 : _overTimeReportData$o4.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [overTimeReportData === null || overTimeReportData === void 0 ? void 0 : overTimeReportData.overTimeReport]);
  var headers = [];
  var overTimeTableData = [];
  if (overTimeReportData !== null && overTimeReportData !== void 0 && (_overTimeReportData$o5 = overTimeReportData.overTimeReport) !== null && _overTimeReportData$o5 !== void 0 && _overTimeReportData$o5.headerData) {
    var _overTimeReportData$o6;
    headers = [{
      Header: "Employees",
      accessor: "employee"
    }, {
      Header: "Overtime Days",
      accessor: "totalOverTime"
    }, {
      Header: "Overtime Hours",
      accessor: "totalOverTimeHours"
    }].concat(_toConsumableArray(overTimeReportData === null || overTimeReportData === void 0 ? void 0 : (_overTimeReportData$o6 = overTimeReportData.overTimeReport) === null || _overTimeReportData$o6 === void 0 ? void 0 : _overTimeReportData$o6.headerData));
  }
  if (overTimeReportData !== null && overTimeReportData !== void 0 && (_overTimeReportData$o7 = overTimeReportData.overTimeReport) !== null && _overTimeReportData$o7 !== void 0 && _overTimeReportData$o7.userData) {
    var _overTimeReportData$o8;
    overTimeTableData = overTimeReportData === null || overTimeReportData === void 0 ? void 0 : (_overTimeReportData$o8 = overTimeReportData.overTimeReport) === null || _overTimeReportData$o8 === void 0 ? void 0 : _overTimeReportData$o8.userData.map(function (d) {
      var day = d.day,
        employee = d.employee,
        totalOverTime = d.totalOverTime,
        employeeId = d.employeeId,
        profileUrl = d.profileUrl,
        totalOverTimeHours = d.totalOverTimeHours;
      var overTimeTableDayData = {};
      day.map(function (dTemp) {
        var date = dTemp.date,
          overTimeHours = dTemp.overTimeHours;
        overTimeTableDayData = _objectSpread(_objectSpread({}, overTimeTableDayData), {}, _defineProperty({}, date, overTimeHours));
      });
      return _objectSpread(_objectSpread({
        employee: employee,
        employeeId: employeeId,
        profileUrl: profileUrl
      }, overTimeTableDayData), {}, {
        totalOverTime: totalOverTime,
        totalOverTimeHours: totalOverTimeHours
      });
    });
  }
  var csvData = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dataValues) {
      var _dataValues$;
      var wb, ws, col, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!dataValues || dataValues.length === 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            col = [{
              header: "Employee",
              key: "employee",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Employee ID",
              key: "employeeId",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            (_dataValues$ = dataValues[0]) === null || _dataValues$ === void 0 ? void 0 : _dataValues$.day.map(function (dTemp) {
              var date = dTemp.date;
              col.push({
                header: date,
                key: date,
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            });
            col.push({
              header: "Over Time Days",
              key: "totalOverTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            col.push({
              header: "Over Time Hours",
              key: "totalOverTimeHours",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            ws.columns = col;
            dataValues.map(function (user) {
              var day = user.day,
                employee = user.employee,
                totalOverTime = user.totalOverTime,
                employeeId = user.employeeId,
                totalOverTimeHours = user.totalOverTimeHours;
              var overTimeReportTableDayData = {};
              day.map(function (dTemp) {
                var date = dTemp.date,
                  overTimeHours = dTemp.overTimeHours;
                overTimeReportTableDayData = _objectSpread(_objectSpread({}, overTimeReportTableDayData), {}, _defineProperty({}, date, overTimeHours));
              });
              ws.addRow(_objectSpread({
                employee: employee,
                employeeId: employeeId,
                totalOverTime: totalOverTime,
                totalOverTimeHours: totalOverTimeHours
              }, overTimeReportTableDayData));
            });
            ws.getRow(1).font = {
              bold: true
            };
            _context.next = 13;
            return wb.xlsx.writeBuffer();
          case 13:
            buf = _context.sent;
            fileName = "workfolio-overtime-".concat(moment(startDate).format("MMMM yyyy"), ".xlsx");
            saveAs(new Blob([buf]), fileName);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [startDate]);
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var totalUsersExport, offset, limit, hasMore, _data$overTimeReportE, _yield$client$query, data, userData;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setIsExporting(true);
            totalUsersExport = [];
            offset = 0;
            limit = 50;
            hasMore = true;
          case 6:
            if (!hasMore) {
              _context2.next = 16;
              break;
            }
            _context2.next = 9;
            return client.query({
              query: OVER_TIME_REPORT_EXPORT_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userParameterCheck.value,
                startTime: Number(moment(dateMoment).startOf("month").format("x")),
                endTime: Number(moment(dateMoment).endOf("month").format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                userRole: role,
                limit: limit,
                offset: offset,
                // Continuations of one batched export. The API charges only the
                // opening request against the export rate limit.
                isBatch: offset > 0
              },
              fetchPolicy: "network-only"
            });
          case 9:
            _yield$client$query = _context2.sent;
            data = _yield$client$query.data;
            userData = (data === null || data === void 0 ? void 0 : (_data$overTimeReportE = data.overTimeReportExport) === null || _data$overTimeReportE === void 0 ? void 0 : _data$overTimeReportE.userData) || [];
            totalUsersExport.push.apply(totalUsersExport, _toConsumableArray(userData));
            if (userData.length < limit || userParameterCheck.value !== null) {
              hasMore = false;
            } else {
              offset += limit;
            }
            _context2.next = 6;
            break;
          case 16:
            if (!(totalUsersExport.length > 0)) {
              _context2.next = 19;
              break;
            }
            _context2.next = 19;
            return csvData(totalUsersExport);
          case 19:
            setIsExporting(false);
            _context2.next = 27;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](0);
            console.error("Export error:", _context2.t0);

            // A 429 is already toasted by the errorLink in apollo/apollo-config.js,
            // which reads the export limiter's own message out of the response body.
            // Everything else was silent: the spinner stopped, no file arrived, and
            // the button looked like it had done nothing.
            if (!isRateLimited(_context2.t0)) {
              toast.error("Export failed. Please try again.");
            }
            setIsExporting(false);
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 22]]);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "monthly-in-out-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-date-picker overtime-report-date-picker"
  }, " ", /*#__PURE__*/React.createElement(DatePicker, {
    selected: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    dateFormat: "MMMM yyyy",
    showMonthYearPicker: true,
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? moment().startOf("month").toDate() : null
  }))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      return getExportData();
    },
    disabled: isExporting
  }, " ", isExporting ? "Downloading..." : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, {
    className: "monthly-attendence-download-icon"
  }), " Export")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")))), /*#__PURE__*/React.createElement(TableGridInOut, {
    headers: headers,
    overTimeTableData: overTimeTableData,
    overTimeReportData: overTimeReportData,
    overTimeReportLoading: overTimeReportLoading,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    overTimeReportFetchMore: overTimeReportFetchMore
  }));
};
var TableGridInOut = function TableGridInOut(props) {
  var headers = props.headers,
    overTimeTableData = props.overTimeTableData,
    overTimeReportData = props.overTimeReportData,
    overTimeReportLoading = props.overTimeReportLoading,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    overTimeReportFetchMore = props.overTimeReportFetchMore;
  var columns = headers;
  var data = overTimeTableData;
  var _useTable = useTable({
      columns: columns,
      data: data
    }),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  var handleLoadMore = function handleLoadMore() {
    var _overTimeReportData$o9, _overTimeReportData$o10;
    if (overTimeReportLoading) return;
    setIsLoadingMore(true);
    overTimeReportFetchMore({
      variables: {
        offset: overTimeReportData === null || overTimeReportData === void 0 ? void 0 : (_overTimeReportData$o9 = overTimeReportData.overTimeReport) === null || _overTimeReportData$o9 === void 0 ? void 0 : (_overTimeReportData$o10 = _overTimeReportData$o9.userData) === null || _overTimeReportData$o10 === void 0 ? void 0 : _overTimeReportData$o10.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$over, _fetchMoreResult$over2, _fetchMoreResult$over3, _fetchMoreResult$over4, _prev$overTimeReport, _fetchMoreResult$over5;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over = fetchMoreResult.overTimeReport) === null || _fetchMoreResult$over === void 0 ? void 0 : (_fetchMoreResult$over2 = _fetchMoreResult$over.userData) === null || _fetchMoreResult$over2 === void 0 ? void 0 : _fetchMoreResult$over2.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$over3 = fetchMoreResult.overTimeReport) === null || _fetchMoreResult$over3 === void 0 ? void 0 : (_fetchMoreResult$over4 = _fetchMoreResult$over3.userData) === null || _fetchMoreResult$over4 === void 0 ? void 0 : _fetchMoreResult$over4.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          overTimeReport: _objectSpread(_objectSpread({}, prev.overTimeReport), {}, {
            userData: [].concat(_toConsumableArray((_prev$overTimeReport = prev.overTimeReport) === null || _prev$overTimeReport === void 0 ? void 0 : _prev$overTimeReport.userData), _toConsumableArray((_fetchMoreResult$over5 = fetchMoreResult.overTimeReport) === null || _fetchMoreResult$over5 === void 0 ? void 0 : _fetchMoreResult$over5.userData))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-in-out-content-view"
  }, /*#__PURE__*/React.createElement("div", {
    className: "monthly-attendence-content"
  }, overTimeReportLoading ? /*#__PURE__*/React.createElement(Loader, null) : !overTimeReportData ? /*#__PURE__*/React.createElement("div", null, "No data") : /*#__PURE__*/React.createElement("table", _extends({
    className: "monthly-attendence-table"
  }, getTableProps()), /*#__PURE__*/React.createElement("thead", {
    className: "overtime-report-thead"
  }, headerGroups.map(function (headerGroup, j) {
    return /*#__PURE__*/React.createElement("tr", _extends({
      className: "monthly-attendence-thead-tr"
    }, headerGroup.getHeaderGroupProps(), {
      key: j
    }), headerGroup.headers.map(function (column, i) {
      return /*#__PURE__*/React.createElement("th", {
        className: "monthly-attendence-thead-tr-th",
        key: i
      }, column.render("Header"));
    }));
  })), /*#__PURE__*/React.createElement("tbody", _extends({
    className: "monthly-attendence-tbody"
  }, getTableBodyProps()), /*#__PURE__*/React.createElement(React.Fragment, null, rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", _extends({
      className: "monthly-attendence-tbody-tr"
    }, row.getRowProps(), {
      key: i
    }), row.cells.map(function (cell, j) {
      if (j === 0) {
        return /*#__PURE__*/React.createElement("th", {
          className: "monthly-attendence-tbody-tr-th ",
          key: j
        }, cell.column.id === "employee" ? /*#__PURE__*/React.createElement("div", {
          className: "daily-attendance-tr-table-grid-employee-displayname-wrapper"
        }, cell.row.original.profileUrl ? /*#__PURE__*/React.createElement("div", {
          "class": "monthly-in-out-table-avatar-profile"
        }, /*#__PURE__*/React.createElement("img", {
          alt: "Workfolio",
          src: cell.row.original.profileUrl,
          "class": "monthly-in-out-table-card-avatar-profile-img"
        })) : /*#__PURE__*/React.createElement("div", {
          className: "daily-attendance-tr-table-grid-employee-avatar-circle text-white"
        }, cell.value.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: !cell.row.original.employeeId ? "daily-attendance-tr-table-grid-employee-name" : ""
        }, cell.value), cell.row.original.employeeId ? /*#__PURE__*/React.createElement("div", {
          className: "daily-attendance-tr-table-grid-employee-id"
        }, "Emp ID: ", cell.row.original.employeeId) : "")) : cell.render("Cell"));
      }
      return /*#__PURE__*/React.createElement("td", _extends({
        className: "monthly-attendence-tbody-tr-td ".concat(cell.value == "-" || cell.value === 0 ? "over-time-report-tbody-tr-td-absent" : cell.value != "-" && cell.value != 0 ? "over-time-report-tbody-tr-td-over-time-data" : "")
      }, cell.getCellProps(), {
        key: j
      }), cell.render("Cell"));
    }));
  })))), !overTimeReportLoading && overTimeReportData && overTimeReportData.length != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users")) : null)));
};
export default OverTimeReport;